import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { XbrlPreviewListingDataResponse } from '../../../types/xbrl-preview';
import { ConversionData } from '../../../types/commons';
import { RuntimeConfigService } from './runtime-config.service';
import { SKIP_GLOBAL_ERROR_REDIRECT } from '../../utils/http-context-tokens.util';

@Injectable({
  providedIn: 'root',
})
export class XbrlPreviewService {
  private readonly config = inject(RuntimeConfigService);
  private readonly API_URL = `${this.config.apiUrl()}/mbrs/xbrl-data-listing`;

  constructor(private http: HttpClient) {}

  fetchXbrlPreviewListing(params: {
    conversionId: string;
  }): Observable<ConversionData> {
    return this.http
      .get<XbrlPreviewListingDataResponse>(`${this.API_URL}`, {
        params,
        withCredentials: true,
        // See SKIP_GLOBAL_ERROR_REDIRECT's own docblock: this call's failure
        // is classified and toasted by FilingFormContainerComponent (the
        // FILING_PREVIEW scope) — the global interceptor's redirect must not
        // win that race.
        context: new HttpContext().set(SKIP_GLOBAL_ERROR_REDIRECT, true),
      })
      // PROPAGATE on failure, never swallow into a fake success envelope.
      // This used to `catchError` every failure — transport AND structured
      // backend rejection alike — into a resolved `of({ status: false, data:
      // <empty stub> })`, the exact anti-pattern
      // `RetrieveMbrsDataService.handleMbrsDataError` carried before
      // `classifyHttpStatus` was introduced (see
      // docs/development/filing-load-diagnostics.md): the caller's `error`
      // callback could never fire, so a network outage here was invisible to
      // both the user and the console, and the sole consumer
      // (`FilingFormContainerComponent`) silently painted an empty file name
      // and a `Failed` status as if the read had actually completed.
      .pipe(map((response) => response.data));
  }
}
